import { CircularProgress } from "@mui/material";
import AppAdminTable from "components/AppAdminTable/AppAdminTable";
import ListPage from "components/ListPage/ListPage";
import { TableColumns } from "helpers/tableColumns";
import { useGetTriggerTypes } from "hooks/useGetTriggerTypes";
import triggerTypesSAService from "services/superadmin/triggerTypesSAService";

const listConfig = [
  {
    key: "order",
    label: "#",
    render: (v: any, i: number) => i + 1,
  },
  {
    key: "name",
    label: "Название",
  },
  {
    key: "platform",
    label: "Платформа",
  },
  {
    key: "type",
    label: "Тип",
  },
  {
    key: "subType",
    label: "Подтип",
  },
  TableColumns.createdDate,
];

export const TriggerTypesList = () => {
  const { data, isLoading, refetch } = useGetTriggerTypes();

  const onDelete = async (u: any) => {
    await triggerTypesSAService.delete(u.id);
    refetch();
  };

  if (isLoading) {
    return (
      <div className="text-center">
        <CircularProgress></CircularProgress>
      </div>
    );
  }

  return (
    <ListPage pageTitle="Типы триггеров" pathToAdd="/superadmin/trigger-types/add">
      <AppAdminTable
        columnConfig={listConfig}
        data={data || []}
        onDelete={onDelete}
        loading={isLoading}
      />
    </ListPage>
  );
};
